export const APP_ENVS = {
  development: 'development',
  staging: 'staging',
  production: 'production',
};
